
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PricesHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fundid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareclasscode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countrycode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languagecode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PricesHistory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fundid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fundid"}}},{"kind":"Argument","name":{"kind":"Name","value":"shareclasscode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareclasscode"}}},{"kind":"Argument","name":{"kind":"Name","value":"countrycode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countrycode"}}},{"kind":"Argument","name":{"kind":"Name","value":"languagecode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languagecode"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prices"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asofdate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"asofdatestd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"viiv"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nav"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"navstd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"navchngval"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currcode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"navchngpct"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mktpriceval"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mktpricevalstd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"applicationprice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"redemptionprice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"masterfundnav"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"weeklyliquidassetratio"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dailyliquidassetratio"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mktchngval"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mktchngpct"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bidoraskspread"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"discountorpremiumincep"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"discountorpremiumatlc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"discountorpremiumatlcstd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"netshareholderflow"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"masternetshareholderflow"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":808}};
    doc.loc.source = {"body":"query PricesHistory(\n  $fundid: String!\n  $shareclasscode: String!\n  $countrycode: String!\n  $languagecode: String!\n) {\n  PricesHistory(\n    fundid: $fundid\n    shareclasscode: $shareclasscode\n    countrycode: $countrycode\n    languagecode: $languagecode\n  ) {\n    prices {\n      asofdate\n      asofdatestd\n      viiv\n      nav\n      navstd\n      navchngval\n      currcode\n      navchngpct\n      mktpriceval\n      mktpricevalstd\n      # discountorpremiumatlc Duplicate field\n      applicationprice\n      redemptionprice\n      masterfundnav\n      weeklyliquidassetratio\n      dailyliquidassetratio\n      mktchngval\n      mktchngpct\n      bidoraskspread\n      discountorpremiumincep\n      discountorpremiumatlc\n      discountorpremiumatlcstd\n      netshareholderflow\n      masternetshareholderflow\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["PricesHistory"] = oneQuery(doc, "PricesHistory");
        
